import { ContentFlexComponent, ContentProps } from "components/flexComponents/Content/typings";
import * as React from "react";
import {
  Action,
  FlexTrackingInfo,
  sendDelayedTrackEvent,
  sendImmediateTrackEvent,
} from "components/utility/analytics/FlexAnalyticsUtils";
import { EditorialWithLink } from "components/flexComponents/Content/factory/impl/editorials/EditorialWithLink";
import EditorialBase from "components/flexComponents/Content/factory/EditorialBase";
import { EditorialFlexModule } from "typings/microserviceModels/content-flex-module";
import { getMABMicroMessage, MABPlatform, MABMicroMessage } from "src/components/utility/analytics/MABAnalyticsUtils";

export class CardWithLinkEditorial extends EditorialBase {
  constructor(editorial: ContentFlexComponent) {
    super(editorial);
  }

  public generate(props: ContentProps) {
    const { analytics, compositionStore, context } = props;

    if (!this.editorial.items[0].media || this.editorial.items[0].media.length === 0) {
      return null;
    }

    const cardClicked = () => {
      const trackingInfo: FlexTrackingInfo = {
        moduleName: this.flexComponent.name,
        rfrr: ((this.flexComponent.model as EditorialFlexModule).title || "").replace(/\s/g, ""),
        action: Action.CLICK,
      };

      const banditContext =
        compositionStore && compositionStore.composition ? compositionStore.composition.bandit : null;

      if (banditContext && context && context.deviceInformation) {
        const {
          deviceInformation,
          site: { id: pos },
        } = context;
        const { mobile, tablet } = deviceInformation;
        const cardLabel = this.editorial.items[0].title ? this.editorial.items[0].title : "";
        const mabTrackingInfo: FlexTrackingInfo = {
          moduleName: "geo_hotels_2",
          rfrr: `editorial.${cardLabel.replace(/ /g, "_")}`,
          action: Action.CLICK,
        };

        const mabTrackingMessage: MABMicroMessage = getMABMicroMessage(
          banditContext,
          "geo_hotels_2",
          "homepageClick.path",
          mobile ? MABPlatform.Mobile : tablet ? MABPlatform.Tablet : MABPlatform.Desktop,
          pos
        );
        sendImmediateTrackEvent(mabTrackingInfo, analytics, mabTrackingMessage);
      }

      sendDelayedTrackEvent(trackingInfo, analytics);
    };

    const uitkClassNames = this.getEditorialItemClassName();

    return (
      <div
        id={this.flexComponent.id}
        data-fm={this.flexComponent.fmId}
        data-fm-title-id={this.flexComponent.fmTitleId}
        className={`uitk-cell uitk-type-center Editorial all-cell-1-1 ${uitkClassNames}`}
        onClick={cardClicked}
        role="button"
      >
        <EditorialWithLink flexComponent={props.flexComponent} l10n={props.l10n} context={props.context} />
      </div>
    );
  }

  public getEditorialItemClassName = (): string =>
    "all-t-margin-three m-b-margin-three l-b-margin-three xl-b-margin-three";
}

export default CardWithLinkEditorial;
